<template>
    <div class="pre-page-div" @click.prevent="back">
        {{title}}
<!--        <van-button type="primary" size="small" style="font-size: 14px;width: 95%;background-color: #005423;"-->
<!--                    @click.prevent="back" round>{{title}}-->
<!--        </van-button>-->
    </div>
</template>
<script>
    export default {
        name: 'prePage',
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        methods: {
            back() {
                this.$emit('back')
            }
        }
    }
</script>
<style type="text/css">
    .pre-page-div {
        width: 100%;
        height: 50px;
        line-height: 50px;
        position: absolute;
        bottom: 0px;
        background-color: white;
        font-size: 16px;
        color: #005423;
        font-weight: bold;
        text-align: center;
    }

</style>
